<header class="scrolled fixed-top">
    <nav class="navbar navbar-expand-lg"
        [ngClass]="{'mobile-nav': screenWidth < 1024, 'desktop-nav': screenWidth >= 1024}">
        <div class="container">
            <div>
                <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbar-content">
                    <span class="fa fa-bars"></span>
                </button>
                <a class="navbar-brand" routerLink="/"><img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/new-theme/ghrscf-white.png"
                        alt="GHRSCF"></a>
            </div>
            <div class="main-navbar collapse navbar-collapse" id="navbar-content">
                <ul class="navbar-nav ms-auto ">
                    <li class="nav-item dropdown">
                        <a class="dropdown-toggle" href="#" data-toggle-mobile><span class="sr-only"></span>About</a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="/about-foundation">About Foundation</a></li>
                            <li><a class="dropdown-item" routerLink="/advisory-board">Advisory Board</a></li>
                            <li><a class="dropdown-item" routerLink="/about-team">About Team</a></li>
                            <li><a class="dropdown-item" routerLink="/mission-vission">Mission & Vission</a></li>
                        </ul>

                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link" routerLink="/events" data-bs-toggle="dropdown"
                            [attr.data-bs-toggle]="isMobile ? 'collapse' : null" data-bs-target="#navbar-content"
                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Events </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link" routerLink="/media" data-bs-toggle="dropdown"
                            [attr.data-bs-toggle]="isMobile ? 'collapse' : null" data-bs-target="#navbar-content"
                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            Media </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link" routerLink="/competition" data-bs-toggle="dropdown"
                            [attr.data-bs-toggle]="isMobile ? 'collapse' : null" data-bs-target="#navbar-content"
                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            Competition</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link" routerLink="/gallery" data-bs-toggle="dropdown"
                            [attr.data-bs-toggle]="isMobile ? 'collapse' : null" data-bs-target="#navbar-content"
                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            Gallery</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link" routerLink="/result" data-bs-toggle="dropdown"
                            [attr.data-bs-toggle]="isMobile ? 'collapse' : null" data-bs-target="#navbar-content"
                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                            Result</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/club" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
                            data-bs-target="#navbar-content" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">Club</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/contact" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
                            data-bs-target="#navbar-content" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">Contact</a>
                    </li>
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-bars"></i>
                        </a>
                        <ul class="dropdown-menu menu-icon" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item"  aria-expanded="false" data-bs-toggle="collapse"
                                data-bs-target="#navbar-content" routerLink="/cultural-events">Cultural Events</a></li>
                            <li><a class="dropdown-item"  aria-expanded="false" data-bs-toggle="collapse"
                                data-bs-target="#navbar-content" routerLink="/sport-events">Sports Events</a></li>
                            <li><a class="dropdown-item"  aria-expanded="false" data-bs-toggle="collapse"
                                data-bs-target="#navbar-content" routerLink="/club">Club</a></li>
                             <li><a class="dropdown-item"  routerLink="/testimonial">Testimonials</a></li>
                        </ul>
                    </li> -->
                </ul>
            </div>
        </div>
    </nav>
</header>
